module.exports = __webpack_public_path__ + "static/media/logotipo_transparente_fundoclaro.95b4b354.png";